import { Col, Container, Row } from 'react-bootstrap';
import SearchBar from './SearchBar';

const SearchBarDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>SearchBar</h4>
            <Container className="d-flex justify-content-between flex-wrap p-0">
              <SearchBar
                placeholder="Search"
                onChange={(e) => console.log(e)}
                onClick={(e) => console.log(e)}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default SearchBarDemo;
